// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Raleway', 'Raleway Fallback'"},"className":"__className_8df82a"};